import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import LocationOn from "@material-ui/icons/LocationOn";
import Phone from "@material-ui/icons/Phone";
import VerifiedUser from "@material-ui/icons/VerifiedUser";

// Branch identity bar for the POS pages. Reads the logged-in console user's
// assigned POS branch (captured in localStorage at login) and shows the
// name / address / phone, the signed-in operator, and an Admin badge.
function BranchBar({ dense }) {
    const name = localStorage.getItem("laundryName") || "";
    const address = (localStorage.getItem("laundryAddress") || "").replace(/\n/g, ", ");
    const phone = localStorage.getItem("laundryPhone") || "";
    const username = localStorage.getItem("username") || "";
    const isAdmin = (localStorage.getItem("userRoles") || "").toUpperCase().includes("ADMIN");

    const hasBranch = !!(name || address || phone);
    if (!hasBranch && !isAdmin) {
        return null;
    }

    const muted = "#525f7f";
    const dot = (
        <Box component="span" style={{ margin: "0 9px", color: "#8898aa" }}>
            &bull;
        </Box>
    );

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            style={{ position: "relative", zIndex: 1, padding: dense ? "4px 2px" : "8px 2px", marginBottom: "1.25rem", rowGap: 10 }}
        >
            {/* Branch identity */}
            <Box display="flex" alignItems="center" style={{ minWidth: 0 }}>
                <Box style={{ minWidth: 0 }}>
                    {/* This theme's h5 is .8125rem (13px), barely above the
                        .75rem (12px) caption used for the address below it, so
                        the branch name read as the same size. Stepped up to the
                        theme's h3 size for a clear hierarchy. */}
                    <Typography variant="h5" style={{ fontSize: "1.0625rem", fontWeight: 700, color: "#32325d", lineHeight: 1.2 }}>
                        {name || "Head Office"}
                    </Typography>
                    <Box display="flex" alignItems="center" flexWrap="wrap" style={{ marginTop: 3, color: muted }}>
                        {address ? (
                            <Box display="flex" alignItems="center">
                                <LocationOn style={{ fontSize: 15, marginRight: 4 }} />
                                <Typography variant="caption">{address}</Typography>
                            </Box>
                        ) : null}
                        {address && phone ? dot : null}
                        {phone ? (
                            <Box display="flex" alignItems="center">
                                <Phone style={{ fontSize: 15, marginRight: 4 }} />
                                <Typography variant="caption">{phone}</Typography>
                            </Box>
                        ) : null}
                        {!address && !phone ? (
                            <Typography variant="caption">No branch assigned</Typography>
                        ) : null}
                    </Box>
                </Box>
            </Box>

            {/* Operator + role */}
            <Box display="flex" alignItems="center">
                {username ? (
                    <Box textAlign="right" style={{ marginRight: 12, lineHeight: 1.15 }}>
                        <Typography variant="caption" style={{ color: muted, display: "block" }}>
                            Signed in
                        </Typography>
                        <Typography variant="body2" style={{ fontWeight: 700, color: "#32325d" }}>
                            {username}
                        </Typography>
                    </Box>
                ) : null}
                {isAdmin ? (
                    <Chip
                        icon={<VerifiedUser style={{ fontSize: 16, color: "#fff" }} />}
                        label="Admin"
                        size="small"
                        style={{ backgroundColor: "#5e72e4", color: "#fff", fontWeight: 700, paddingLeft: 4 }}
                    />
                ) : null}
            </Box>
        </Box>
    );
}

export default BranchBar;
